/**
 * @generated SignedSource<<01d01d780bbb18df99b50f58dff50834>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  "contributions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contributionsCount"
    },
    {
      "kind": "RootArgument",
      "name": "contributionsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "contributionsFilters"
    },
    {
      "kind": "RootArgument",
      "name": "contributionsSort"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "contributionsCount",
        "cursor": "contributionsCursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "contributionsCount",
          "cursor": "contributionsCursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ContributionsDatavizListThemePaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ContributionsDatavizListTheme_theme",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "participativeModule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsDatavizMainContainerHeader_participativeModule"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "contributions",
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "contributionsFilters"
        },
        {
          "kind": "Variable",
          "name": "sort",
          "variableName": "contributionsSort"
        }
      ],
      "concreteType": "ContributionConnection",
      "kind": "LinkedField",
      "name": "__ContributionsList_contributions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContributionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Contribution",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isMine",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isBookmarked",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Theme",
                  "kind": "LinkedField",
                  "name": "themes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContributionsDatavizListThemeContribution_contribution"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizThemeLayout_theme"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizListThemeContribution_theme"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizMainContainerHeader_theme"
    },
    (v1/*: any*/)
  ],
  "type": "Theme",
  "abstractKey": null
};
})();

node.hash = "0c2baa2e2e7a3dec8f28ea18000704a6";

module.exports = node;
